export default __webpack_public_path__ + "static/media/Academic Calender 10.d04e465b.pdf";